import {defineStore as _defineStore} from 'pinia'

export function defineStore(config) {
    return _defineStore('user', {
        state: () => ({
            isAuthenticated: false,
            lastVisitedRoute: null,
            ...config.state
        }),
        getters: {
            ...config.getters
        },
        actions: {
            async login(params) {
               console.log(params)
            },
            async logout() {
            },
            ...config.actions
        },
    })
}
